import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

function useAnswerValidationSchema() {
    const { t } = useTranslation('validationsSchema');

    const schema = yup
        .object({
            question: yup
                .string()
                .required(t('invalidQuestionAnswerFormat')),  
            answers: yup
                .array()
                .of(
                    yup.object({
                        index: yup
                            .string()
                            .required(t('invalidQuestionAnswerFormat')),  
                        text: yup
                            .string()
                            .required(t('invalidQuestionAnswerFormat'))  
                    })
                )
                .min(2, t('minAnswers')) 
        })

    return schema;
}

export default useAnswerValidationSchema;
